import { render, staticRenderFns } from "./accessoryAccountingSheetDetail.vue?vue&type=template&id=3936a473&scoped=true"
import script from "./accessoryAccountingSheetDetail.vue?vue&type=script&lang=js"
export * from "./accessoryAccountingSheetDetail.vue?vue&type=script&lang=js"
import style0 from "./accessoryAccountingSheetDetail.vue?vue&type=style&index=0&id=3936a473&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3936a473",
  null
  
)

export default component.exports